import React, { useContext, useEffect, useState } from 'react'
import Line from "../../../assets/images/line.png"
import Icon from "../../../assets/images/brush.png"
import { useNavigate, useParams } from 'react-router-dom'
import { revertSlug, slugGenerator } from '../../../utils/slugGenerator'
import Breadcrumbs from '../../common/Breadcrumbs'
import { notification, Switch } from 'antd'
import AboutImg from "../../../assets/images/about.png"
import AboutIcon from "../../../assets/images/about-icon.png"
import { axiosInstance, config } from '../config'
import Loader from "../../common/Loader"
import secureLocalStorage from 'react-secure-storage'
import { ServicesContext } from '../../Reusable/ServiceContextmain'
import { Helmet } from 'react-helmet'

const ServiceDetails = () => {

    const Navigate = useNavigate();

    const [sideMenu, setSideMenu] = useState(false);
    const { services, loading, error } = useContext(ServicesContext);
    const [isTenderQuery, setIsTenderQuery] = useState(false);
    const [Loading , setLoading] = useState(false);
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        datetime: '',
        servicename: '',
        message: '',
        noOfProperties: ''
    });
    const { slug } = useParams();

    const [errors, setErrors] = useState({
        name: '',
        email: '',
        phone: '',
        datetime: '',
        servicename: '',
        message: ''
    });
    

    const today = new Date();
    // Format the date to YYYY-MM-DDTHH:MM for the datetime-local input
    const minDateTime = today.toISOString().slice(0, 16);
    const [ServiceDetails , setServiceDetails] = useState();

    useEffect(() => {
        if (slug) {
            const parts = slug.split('/'); // Assuming the parts are separated by hyphens
            const lastName = parts[parts.length - 1]; // Get the last part
            
            getservicedata(lastName);
            
        }
    }, [slug]);

    const getservicedata = async(lastName) => {
        setLoading(true);
        axiosInstance.get(`/services/${lastName}`)
            .then(res => {
                if(!res?.data?.service){
                    Navigate(`${config.appUrl}services`);
                }
                setServiceDetails(res?.data?.service)
                setFormData({
                    servicename : res?.data?.service?.id
                })
                setLoading(false);
            })
            .catch((err) => {
                setLoading(false);
                if(err?.response?.data?.message === "Service not found"){
                    Navigate(`${config.appUrl}services`);
                }

                console.log(err);
            })
            .finally(() => {
                setLoading(false);
                // Any additional cleanup if needed
        });
    }

    const validate = () => {
        const newErrors = {};
        if (!formData.name) newErrors.name = "Name is required.";
        if (!formData.email) {
            newErrors.email = "Email is required.";
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
            newErrors.email = "Email is invalid.";
        }
        if(!formData.datetime) newErrors.datetime = "Date and time are required.";
        if (!formData.phone) newErrors.phone = "Phone number is required.";
        if (formData.servicename === 'Your Service') newErrors.servicename = "Please select a service.";
        if (!formData.message) newErrors.message = "Message is required.";
        
        return newErrors;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async(e) => {
        e.preventDefault();

        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
        } else {
            setLoading(true);
            try{
                const EnquiryData = {...formData , tendercontract : isTenderQuery ? 1 : 0}
    
                const response = await axiosInstance.post(`/inquiry/add` , EnquiryData);
                if(response?.data?.success){
                    setSideMenu(false)
                    notification.open({
                        message: (
                            <div className="d-flex">
                                <div className="pr-20">
                                    <i
                                        className="bi bi-check2-circle text-success"
                                        style={{ fontSize: "20px" }}
                                    ></i>
                                </div>
                                <div>Enquiry Submitted Successfully</div>
                            </div>
                        ),
                        description: "You can expect a call in 24 hours from our team.",
                    });
                    setLoading(false);
                    setFormData({
                        name: '',
                        email: '',
                        phone: '',
                        datetime: '',
                        servicename: '',
                        message: '',
                        noOfProperties: ''
                    })
                }else{
                    setSideMenu(false);
                    notification.open({
                        message: (
                          <div className="d-flex">
                            <div className="pr-20">
                              <i
                                className="bi bi-exclamation-circle-fill text-danger"
                                style={{ fontSize: "20px" }}
                              ></i>
                            </div>
                            <div>Opps! Something went wrong.</div>
                          </div>
                        ),
                        description: "Try Again !",
                    });
                    setFormData({
                        name: '',
                        email: '',
                        phone: '',
                        datetime: '',
                        servicename: '',
                        message: '',
                        noOfProperties: ''
                    })
                }
            }catch(e){
                setLoading(false);
            }
        }
    };

    const handleSwitchChange = (checked) => {
        setIsTenderQuery(checked); // Update the state based on the switch value
    };


    const Description = ServiceDetails ? JSON.parse(ServiceDetails?.description) : [];
    // console.log(Description);

    return (
        <>
            <Helmet>
                <title>{ServiceDetails?.metatitle || "Precision Contract Cleaning"}</title>
                <meta name="description" content={ServiceDetails?.metadescription || "Precision Contract Cleaning"} />
                <meta name="keywords" content={ServiceDetails?.metakeywords || "Precision Contract Cleaning"} />
            </Helmet>
            {Loading && <Loader/>}
            <div className={sideMenu ? "nav-expanded" : ""}>
                <div class="offwrap"></div>
                <div className='full-width-header'>
                    <Breadcrumbs title={ServiceDetails?.name} description={ Description[0]}
                        image={`${config.imageurl}${ServiceDetails?.image}`}
                    />
                        <div className="rs-choose choose-style1 pt-120 md-pt-80 ">
                            <div className="container">
                                <div className="row y-middle">
                                    <div className="col-lg-6 md-mb-50">
                                        <div className="sec-title2">
                                            <div className="brush-content mb-20">
                                                <img src={Icon} alt="" />
                                                <span className="sub-text">About Service</span>
                                            </div>
                                            <div className='d-flex align-items-center'>
                                                <p dangerouslySetInnerHTML={{__html : Description[1]}}></p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="about-choose-us">
                                            <div className="about-video1 ps-md-5">
                                                <img src={`${config.imageurl}${ServiceDetails?.image2}`} className=''></img>
                                                {/* <div className="rs-videos">
                                                    <div className="animate-border">
                                                        <a className="popup-border popup-videos" href="#">
                                                            <i className="bi bi-play-fill"></i>
                                                        </a>
                                                    </div>
                                                </div> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row y-middle pt-120 md-pt-80">
                                    <div className="col-lg-6 md-mb-50 pe-md-5">
                                        <div className="about-images service-details">
                                            <img src={`${config.imageurl}${ServiceDetails?.image3}`} alt="" />
                                        </div>
                                    </div>
                                    <div className="col-lg-6 pr-55 md-pr-15">
                                        <div className='sec-title2'>
                                            <div dangerouslySetInnerHTML={{__html : Description[2]}}></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    {/* first section about service */}
                    <div className="rs-about pt-120 pb-120 md-pt-80 md-pb-70">
                        <div className="container">
                            <div className="row y-middle">
                                <div class="sec-title text-center mb-5">
                                    <h2 class="title">
                                        Explore Our Services
                                    </h2>
                                    <div class="line-img process-center wow fadeInUp" >
                                        <img src={Line} alt="Images" />
                                    </div>
                                </div>
                                {ServiceDetails?.sub_services?.map((serv, i) => {
                                    return (
                                        <div className='col-md-4' key={i}>
                                            <div className='service-detail-box mb-4'>
                                                <div className="brush-content mb-20">
                                                    <img src={Icon} alt="" width="25" />
                                                    <span className="sub-text ps-2">
                                                        {serv?.name}
                                                    </span>
                                                </div>

                                                <p>{serv?.description}</p>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                            <div class="btn-part text-center mt-4">
                                <a class="readon about" onClick={() => setSideMenu(true)}><span class="btn-text">Inquiry Now</span></a></div>
                        </div>
                    </div>
                    <nav className="right_menu_togle menu-wrap-off service-box ">
                        <div className="close-btn">
                            <a id="nav-close" className="nav-close" onClick={() => setSideMenu(false)}>
                                <div className="line">
                                    <span className="line1"></span>
                                    <span className="line2"></span>
                                </div>
                            </a>
                        </div>
                        <div className="rs-offcanvas-inner">
                            <div className="offcanvas-text">
                                <h4 className=''>Get Clean Today!</h4>
                            </div>
                            <div className='rs-contact contact-style3 '>
                                <div className='contact-drop-line p-0 bg-transparent'>
                                    <div className="canvas-contact">
                                        <form id="contact-form"  onSubmit={handleSubmit}>
                                            <fieldset>
                                                <div className="row service-form">
                                                    <div className="col-lg-12 mb-3">
                                                        <input
                                                            className="from-control"
                                                            type="text"
                                                            name='name'
                                                            placeholder="Name *"
                                                            value={formData.name}
                                                            onChange={handleChange}
                                                        />
                                                        {errors.name && <span className="text-danger ps-2" style={{fontSize:"14px"}}>* {errors.name}</span>}
                                                    </div>
                                                    <div className="col-lg-12 mb-3">
                                                        <input
                                                            className="from-control"
                                                            type="email"
                                                            name='email'
                                                            placeholder="E-Mail *"
                                                            value={formData.email}
                                                            onChange={handleChange}
                                                        />
                                                        {errors.email && <span className="text-danger ps-2" style={{fontSize:"14px"}}>* {errors.email}</span>}
                                                    </div>
                                                    <div className="col-lg-12 mb-3">
                                                        <input
                                                            className="from-control"
                                                            type="text"
                                                            name='phone'
                                                            placeholder="Phone Number *"
                                                            value={formData.phone}
                                                            maxLength={11}
                                                            onChange={handleChange}
                                                        />
                                                        {errors.phone && <span className="text-danger ps-2" style={{fontSize:"14px"}}>* {errors.phone}</span>}
                                                    </div>
                                                    <div className="col-lg-12 mb-3">
                                                        <input
                                                            className="from-control date"
                                                            type="datetime-local"
                                                            placeholder="Date"
                                                            name='datetime'
                                                            value={formData.datetime}
                                                            onChange={handleChange}
                                                            min={minDateTime}
                                                        />
                                                        <br className='d-block d-xl-none'/>
                                                        {errors.datetime && <span className="text-danger ps-2" style={{fontSize:"14px"}}>* {errors.datetime}</span>}
                                                    </div>
                                                    <div className="col-12 mb-3">
                                                        <select
                                                            name="servicename"
                                                            className="wpcf7-form-control wpcf7-select wpcf7-validates-as-required select-no-dropdown"
                                                            value={formData.servicename}
                                                            disabled
                                                            onChange={handleChange}
                                                        >
                                                            {services?.map((item) => (
                                                                <option value={item?.id}>{item?.name}</option>
                                                            ))}
                                                        </select>
                                                        {errors.servicename && <span className="text-danger ps-2" style={{fontSize:"14px"}}>* {errors.servicename}</span>}
                                                    </div>
                                                    <div className='d-flex justify-content-between'>
                                                        <h6 className='form-Query mb-3'>Is This Query For Tender Contract?</h6>
                                                        <Switch
                                                            defaultChecked={false}
                                                            onChange={handleSwitchChange}
                                                            
                                                        />
                                                    </div>
                                                    {isTenderQuery && (
                                                        <div className="col-lg-12 mb-3">
                                                            <input
                                                                type="number"
                                                                min={1}
                                                                className="form-control"
                                                                id="noOfProperties"
                                                                name="noOfProperties"
                                                                placeholder="No. of Properties"
                                                                value={formData.noOfProperties}
                                                                onChange={handleChange}
                                                            />
                                                        </div>
                                                    )}
                                                    <div className="col-lg-12 mb-3">
                                                        <textarea
                                                            className="from-control"
                                                            id="message"
                                                            name="message"
                                                            placeholder="Your Message *"
                                                            value={formData.message}
                                                            onChange={handleChange}
                                                        />
                                                        {errors.message && <span className="text-danger ps-2" style={{fontSize:"14px"}}>* {errors.message}</span>}
                                                    </div>
                                                </div>
                                                <div className="btn-part">
                                                    <div className="form-group mb-0">
                                                        <p className="submit-btn submit-btn3">
                                                            <input type="submit" defaultValue="Submit Now" />
                                                        </p>
                                                    </div>
                                                </div>
                                            </fieldset>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </nav>
                </div>
            </div>
        </>
    )
}

export default ServiceDetails